import { render, staticRenderFns } from "./ListBoard.vue?vue&type=template&id=1498a650&scoped=true&"
import script from "./ListBoard.vue?vue&type=script&lang=js&"
export * from "./ListBoard.vue?vue&type=script&lang=js&"
import style0 from "./ListBoard.vue?vue&type=style&index=0&id=1498a650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1498a650",
  null
  
)

export default component.exports